module.exports = __webpack_public_path__ + "static/media/017.85363aa7.jpg";